import { Component, Input } from '@angular/core';
import { SessionStorageService } from '@app/core/services/session-storage.service';

@Component({
  selector: 'performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.scss']
})


export class PerformanceComponent {
@Input()  PersonName: string;
@Input()  Percent: number;
@Input() IsGroup: boolean;


/**
 *
 */
constructor(
  public sessionStorageService : SessionStorageService
) {
  
  }


    personalPerformanceClass() {
      if(this.Percent>= 0 && this.Percent <= 33) {
        return {
          'red-performance': true
        }
      }
      if( this.Percent > 33 && this.Percent <= 66) {
        return {
          'yellow-performance': true
        }
      }
      if( this.Percent >=66  && this.Percent <= 10000000) {
        return {
          'green-performance': true
        }
      }
    }
  
    groupPerformanceClass() {
      if( this.Percent >= 0 && this.Percent <= 33) {
        return {
          'red-performance': true
        }
      }
      if( this.Percent > 33 && this.Percent <= 66) {
        return {
          'yellow-performance': true
        }
      }
      if( this.Percent>=66  && this.Percent <= 10000000) {
        return {
          'green-performance': true
        }
      }
    }
  
}   
